import { gql } from '@apollo/client';
import { COMPANY_BASIC_RESULTS_FRAGMENT } from '../company';
import { USER_BASIC_FIELDS, ID_NAME_FIELDS } from 'graphql/common/fragments';

export const TIM_FRAGMENT = gql`
  fragment TIMFragment on TIM {
    id
    expandingContracting {
      ${ID_NAME_FIELDS}
    }
    targetMarketId
    targetMarket {
      ${ID_NAME_FIELDS}
      mediaUrl
      country {
        areaMeasurement
        distanceMeasurement
      }
    }
    targetSubmarkets {
      ${ID_NAME_FIELDS}
    }
    targetPropertyTypeId
    targetPropertyType {
      ${ID_NAME_FIELDS}
    }
    targetPropertySubTypeId
    targetThirdPartyPropertyClassId
    targetThirdPartyPropertyClass {
      ${ID_NAME_FIELDS}
    }
    targetSizeMax
    targetSizeMin
    targetSizeMaxMt
    targetSizeMinMt
    timStatusType {
      ${ID_NAME_FIELDS}
    }
    timStatusTypeId
    currentMarketId
    currentMarket {
      ${ID_NAME_FIELDS}
    }
    currentPropertyId
    currentProperty {
      ${ID_NAME_FIELDS}
      primaryAddress
    }
    currentLeaseId
    currentSize
    currentSizeMt
    newToMarket
    source
    comments
    clearHeightHigh
    clearHeightLow
    clearHeightHighMt
    clearHeightLowMt
    loadingDocks
    driveInDoors
    dockConfigurationType {
      ${ID_NAME_FIELDS}
    }
    dockConfigurationTypeId
    trailerParkingSpaces
    activeSinceDate
    exitDate
    targetCommencementDate
    lastDiscussedDate
    tenantRepBrokerCompany {
      ${ID_NAME_FIELDS}
    }
    tenantCompany {
      ...companyBasicResults
    }
    tenantRepBroker {
      ${ID_NAME_FIELDS}
    }
    createdAt
    updatedAt
    createdUser {
      ${USER_BASIC_FIELDS}
    }
    updatedUser {
      ${USER_BASIC_FIELDS}
    }
  }
  ${COMPANY_BASIC_RESULTS_FRAGMENT}
`;
